import moment from 'moment';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'react-emotion';

import EventCardDetails from './EventCardDetails/EventCardDetails';
import Shadow from '../../../../components/Shadow/Shadow';
import Style from '../../../../styles/common';

const Container = styled('div')`
  display: inline-block;
  height: 210px;
  margin: ${Style.SPACING.M};
  position: relative;
  vertical-align: top;
  width: 390px;
`;

const Card = styled('div')`
  background-color: ${Style.color.cardBackground};
  border-radius: ${Style.BORDER_RADIUS};
  cursor: pointer;
  display: flex;
  height: 100%;
  position: relative;
  width: 100%;
  z-index: 1;
`;

const Content = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 0 ${Style.SPACING.XS} 0 ${Style.SPACING.M};
  overflow: hidden;
`;

const Image = styled('div')`
  background-image: url(${props => props.imageUrl});
  background-position: center;
  background-size: auto 110%;
  border-bottom-left-radius: ${Style.BORDER_RADIUS};
  border-top-left-radius: ${Style.BORDER_RADIUS};
  flex-shrink: 0;
  position: relative;
  width: 130px;
`;

class EventCard extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    startDateTime: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  };

  state = {
    hover: false,
    redirect: false,
  };

  render() {
    if (this.state.redirect) {
      return <Redirect push to={`/event/${this.props.id}`} />;
    }

    const momentValue = moment.unix(this.props.startDateTime);
    const dateTime = momentValue.format('ddd, MMM D, h:mm a');

    return (
      <Container>
        <Card
          onClick={this.handleClick}
          onMouseOver={this.setHoverState}
          onMouseOut={this.unsetHoverState}
        >
          <Image imageUrl={this.props.imageUrl} />
          <Content>
            <EventCardDetails
              dateTime={dateTime}
              location={this.props.location}
              title={this.props.title}
            />
          </Content>
        </Card>
        <Shadow hover={this.state.hover} />
      </Container>
    );
  }

  handleClick = () => {
    this.setState({ redirect: true });
  };

  setHoverState = () => {
    this.setState({ hover: true });
  };

  unsetHoverState = () => {
    this.setState({ hover: false });
  };
}

export default EventCard;



// WEBPACK FOOTER //
// ./src/views/Browse/Events/EventCard/EventCard.js